import { Chip, Stack } from '@mui/material';
import React from 'react';
import {
  INTEGRATION_CATEGORY_LABELS,
  INTEGRATION_CATEGORY_ORDER,
  type IntegrationCategory,
} from '../../ThirdPartyIntegration/categories';

interface IntegrationCategoryChipsProps {
  selected: IntegrationCategory | 'all';
  onChange: (category: IntegrationCategory | 'all') => void;
  availableCategories: Set<IntegrationCategory>;
  isDark: boolean;
}

const IntegrationCategoryChips: React.FC<IntegrationCategoryChipsProps> = ({
  selected,
  onChange,
  availableCategories,
  isDark,
}) => {
  const baseChipSx = (active: boolean) => ({
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: 500,
    height: 28,
    backgroundColor: active
      ? isDark
        ? 'rgba(127, 86, 217, 0.25)'
        : 'rgba(105, 65, 198, 0.10)'
      : isDark
        ? 'rgba(71, 84, 103, 0.20)'
        : '#F2F4F7',
    color: active
      ? isDark
        ? '#D6BBFB'
        : '#6941C6'
      : isDark
        ? '#D0D5DD'
        : '#344054',
    border: '1px solid',
    borderColor: active ? (isDark ? '#7F56D9' : '#6941C6') : 'transparent',
    cursor: 'pointer',
  });

  return (
    <Stack direction='row' spacing={1} flexWrap='wrap' useFlexGap>
      <Chip
        label='All'
        onClick={() => onChange('all')}
        sx={baseChipSx(selected === 'all')}
      />
      {INTEGRATION_CATEGORY_ORDER.filter(category =>
        availableCategories.has(category),
      ).map(category => (
        <Chip
          key={category}
          label={INTEGRATION_CATEGORY_LABELS[category]}
          onClick={() => onChange(category)}
          sx={baseChipSx(selected === category)}
        />
      ))}
    </Stack>
  );
};

export default IntegrationCategoryChips;
